import { graphql } from "@/lib/gql/__generated__/gql";

export const PLAIN_SETTING_FOR_DESIGN_PLAIN_QUERY = graphql(/* GraphQL */ `
	query PlainSettingForDesignPlain($hotelID: ID!) {
		plainSetting(hotelID: $hotelID) {
			id
			hotelID
			domainName
			logoImage {
				bucket
				key
				region
				mimeType
				fileName
			}
			logoSize
			backgroundType
			backgroundImage {
				bucket
				key
				region
				mimeType
				fileName
			}
			colorBackground
			colorPrimary
			colorFont
			isShowHotelName
			isShowHotelLogo
			isShowHotelCatchCopy
			isShowHotelKeyVisual
			fontFamily
			widgetDecoration
			isShowMagazinePlan
			isShowMagazineRoom
			isShowMagazineAbout
			gtmID
			reservationComponentType
		}
		guestPageVisibilitySettings(hotelID: $hotelID) {
			id
			hotelID
			plainVisibility
			magazineVisibility
			snackVisibility
		}
		hotel(hotelID: $hotelID) {
			name
			catchCopy
			mainKeyVisual {
				bucket
				key
				region
				mimeType
				fileName
			}
			article {
				bucket
				key
				region
				mimeType
				fileName
			}
		}
		roomList(hotelID: $hotelID) {
			rooms {
				name
				roomSize
				capacityPeopleMaximum
				mainKeyVisual {
					bucket
					key
					region
					mimeType
					fileName
				}
			}
		}
		planList(hotelID: $hotelID) {
			plans {
				name
				price {
					amount
				}
				mainTarget
				billingTypeTarget
				billingTypeTerm
				mainKeyVisual {
					bucket
					key
					region
					mimeType
					fileName
				}
				isDayTrip
			}
		}
	}
`);
